import React from 'react';
import { useTranslation } from 'react-i18next';

const About: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#0A4A7A] mb-8">{t('about.title')}</h1>
        <div className="prose prose-lg max-w-none">
          <p className="text-xl text-gray-700 mb-6">{t('about.intro')}</p>
          <p className="text-gray-700 mb-6">{t('about.missionText')}</p>
          <h2 className="text-2xl font-semibold text-[#0A4A7A] mb-4">{t('about.whyTitle')}</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
            <li>{t('about.why1')}</li>
            <li>{t('about.why2')}</li>
            <li>{t('about.why3')}</li>
            <li>{t('about.why4')}</li>
            <li>{t('about.why5')}</li>
          </ul>
          <a href="https://www.bokadirekt.se/places/varmdo-horsel-134414" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#0A4A7A] text-white px-8 py-3 rounded font-semibold hover:bg-[#083d66] transition-colors mt-6">
            {t('hero.cta')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
